<template>
  <div class="home-b2b">
    <!-- Top Access Login Bar -->
    <div
      class="login-access-bar bg-primary-dark-base text-white py-2 px-3
        d-flex align-items-center justify-content-between text-small"
    >
      <div class="d-none d-md-flex align-items-center">
        <span class="badge badge-success-base mr-2">AMII</span>
        <span class="small opacity-90">
          La plataforma líder de gestión e IA para profesionales de la salud
        </span>
      </div>
      <div class="d-flex align-items-center ml-auto">
        <a
          href="https://paciente.amii.app"
          class="btn btn-outline-light btn-xs mr-2 px-3 rounded-pill
            text-decoration-none"
        >
          Acceso Pacientes
        </a>
        <a
          href="https://medico.amii.app"
          class="btn btn-success-base btn-xs px-3 rounded-pill text-white
            font-weight-bold text-decoration-none"
        >
          Iniciar Sesión Médico
        </a>
      </div>
    </div>

    <!-- 1. Hero B2B Section -->
    <HeroB2B
      @open-directory="scrollToDirectory"
      @start-register="scrollToPricingOrRegister"
      @scroll-vsl="scrollToVsl"
    />

    <!-- 2. VSL (Video Sales Letter) Section -->
    <!-- <VslVideoPlayer
      ref="vslPlayer"
      @start-register="scrollToPricingOrRegister"
    /> -->

    <!-- 3. Social Proof Bar -->
    <SocialProofBar />

    <!-- 4. Before vs After Comparison -->
    <BeforeAfterComparison />

    <!-- 5. Specialty Selector -->
    <SpecialtySelector />

    <!-- 6. AMII Voice Showcase -->
    <AmiiVoiceShowcase
      @start-register="scrollToPricingOrRegister"
    />

    <!-- 7. Video Testimonials -->
    <VideoTestimonials />

    <!-- 8. Human Support Guarantee -->
    <HumanSupportGuarantee
      @start-register="scrollToPricingOrRegister"
    />

    <!-- 9. Pricing Table ROI -->
    <PricingTableROI
      ref="pricingTable"
      @start-register="scrollToPricingOrRegister"
    />

    <!-- 10. FAQ Accordion -->
    <FaqAccordion />

    <!-- 11. Final CTA Form -->
    <FinalCtaForm
      @start-register="scrollToPricingOrRegister"
    />

    <!-- 12. Registration Form Section -->
    <div
      id="formulario-registro-medico"
      class="w-100 bg-light py-5 px-3 border-top border-bottom"
    >
      <div class="container">
        <FormularioRegistro
          :check-term="checkTerm"
          :code="code"
          @alerta-msj="alertaMsj = $event"
          @clean-check-term="checkTerm = false"
          @show-terms="showTermsCondtion = true"
        />
      </div>
    </div>

    <!-- 13. Directorio Médico CTA Preview Section -->
    <section
      id="reserva-tu-cita"
      class="w-100 bg-primary-dark-base py-5 px-3 position-relative
        overflow-hidden"
    >
      <div
        id="directorio"
        class="container"
      >
        <div
          class="card shadow-lg p-4 p-md-5 rounded-xl bg-white text-dark
            text-center position-relative"
        >
          <div class="max-w-700 mx-auto">
            <span
              class="badge badge-primary-base px-3 py-2 text-uppercase
                font-weight-bold mb-3 rounded-pill"
            >
              Directorio Médico AMII
            </span>
            <h2 class="h2 font-weight-bold text-dark-blue mb-3">
              Encuentra a tu Especialista Ideal
            </h2>
            <p class="lead text-muted mb-4">
              Explora cientos de especialistas certificados e instituciones
              médicas. Consulta opiniones reales de pacientes y agenda tu
              cita en línea al instante.
            </p>

            <div class="d-flex justify-content-center flex-wrap gap-2">
              <router-link
                to="/directorio"
                class="btn btn-success-base btn-lg px-5 py-3 font-weight-bold
                  rounded-pill text-white text-decoration-none shadow-md
                  btn-pulse-success"
              >
                <font-awesome-icon
                  icon="search"
                  class="mr-2"
                />
                Explorar Directorio Completo
              </router-link>
            </div>

            <div class="row justify-content-center mt-4 text-muted small">
              <div class="col-auto d-flex align-items-center mb-2">
                <font-awesome-icon
                  icon="check-circle"
                  class="text-success-base mr-2"
                />
                Especialistas verificados
              </div>
              <div class="col-auto d-flex align-items-center mb-2">
                <font-awesome-icon
                  icon="star"
                  class="text-warning mr-2"
                />
                Opiniones y valoraciones reales
              </div>
              <div class="col-auto d-flex align-items-center mb-2">
                <font-awesome-icon
                  icon="calendar-check"
                  class="text-primary-base mr-2"
                />
                Citas 24/7 sin esperas
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Modals & Helpers -->
    <AlertaMsj
      :alerta-msj="alertaMsj"
      @cerrar="alertaMsj.content = ''"
    />

    <termsCondition
      ref="componentTermsCondition"
      :show="showTermsCondtion"
      @assigning-values="assigningValues"
    />
  </div>
</template>

<script>
import AlertaMsj from '@/components/AlertaMsj.vue';
import HeroB2B from '@/components/landing/HeroB2B.vue';
// import VslVideoPlayer from '@/components/landing/VslVideoPlayer.vue';
import SocialProofBar from '@/components/landing/SocialProofBar.vue';
import BeforeAfterComparison
from '@/components/landing/BeforeAfterComparison.vue';
import SpecialtySelector from '@/components/landing/SpecialtySelector.vue';
import AmiiVoiceShowcase from '@/components/landing/AmiiVoiceShowcase.vue';
import VideoTestimonials from '@/components/landing/VideoTestimonials.vue';
import HumanSupportGuarantee
from '@/components/landing/HumanSupportGuarantee.vue';
import PricingTableROI from '@/components/landing/PricingTableROI.vue';
import FaqAccordion from '@/components/landing/FaqAccordion.vue';
import FinalCtaForm from '@/components/landing/FinalCtaForm.vue';
import FormularioRegistro from '@/components/formularioRegistro';
import termsCondition from '@/components/TerminosCondiciones';

export default {
  name: 'Home',
  components: {
    AlertaMsj,
    HeroB2B,
    // VslVideoPlayer,
    SocialProofBar,
    BeforeAfterComparison,
    SpecialtySelector,
    AmiiVoiceShowcase,
    VideoTestimonials,
    HumanSupportGuarantee,
    PricingTableROI,
    FaqAccordion,
    FinalCtaForm,
    FormularioRegistro,
    termsCondition,
  },
  data() {
    return {
      alertaMsj: {content: ''},
      checkTerm: false,
      showTermsCondtion: false,
      code: '',
    };
  },
  created() {
    const q = this.$route.query;
    if (q && (q.ref || q.code)) {
      this.code = q.ref || q.code || '';
    }
  },
  mounted() {
    this.initChatbot();
    if (
      this.$route
      && (
        this.$route.name === 'directorio'
        || this.$route.path === '/directorio'
        || this.$route.hash === '#directorio'
        || this.$route.hash === '#reserva-tu-cita'
      )
    ) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToDirectory();
        }, 300);
      });
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined' && window.$chatwoot) {
      if (typeof window.$chatwoot.toggle === 'function') {
        window.$chatwoot.toggle('hide');
      } else if (typeof window.$chatwoot.hide === 'function') {
        window.$chatwoot.hide();
      }
    }
  },
  methods: {
    scrollToDirectory() {
      if (this.$router && this.$route && this.$route.path !== '/directorio') {
        this.$router.push('/directorio');
      } else {
        const el = document.getElementById('reserva-tu-cita')
          || document.getElementById('directorio');
        if (el) el.scrollIntoView({behavior: 'smooth'});
      }
    },
    initChatbot() {
      if (typeof window === 'undefined') return;
      if (
        this.$route
        && (
          this.$route.name === 'PerfilDeUsuario'
          || this.$route.name === 'labClinico'
          || this.$route.path === '/lab-clinico'
          || this.$route.name === 'directorio'
          || this.$route.path === '/directorio'
        )
      ) {
        return;
      }
      if (window.chatwootSDK) {
        if (window.$chatwoot) {
          if (typeof window.$chatwoot.toggle === 'function') {
            window.$chatwoot.toggle('show');
          } else if (typeof window.$chatwoot.show === 'function') {
            window.$chatwoot.show();
          }
        }
        return;
      }
      if (document.getElementById('chatwoot-sdk-script')) return;
      (function(d, t) {
        const BASE_URL = 'https://bots.amii.app';
        const g = d.createElement(t);
        const s = d.getElementsByTagName(t)[0];
        g.id = 'chatwoot-sdk-script';
        g.src = BASE_URL + '/packs/js/sdk.js';
        g.async = true;
        s.parentNode.insertBefore(g, s);
        g.onload = function() {
          if (window.chatwootSDK) {
            window.chatwootSDK.run({
              websiteToken: 'RVrJdr7eGyNgKc6Wrcox9r6x',
              baseUrl: BASE_URL,
            });
          }
        };
      })(document, 'script');
    },
    scrollToVsl() {
      const el = document.getElementById('vsl-section');
      if (el) el.scrollIntoView({behavior: 'smooth'});
    },
    scrollToPricingOrRegister() {
      const el = document.getElementById('formulario-registro-medico')
        || document.getElementById('pricing-section');
      if (el) {
        el.scrollIntoView({behavior: 'smooth'});
      } else {
        window.location.href = 'https://amii.app/soy-medico';
      }
    },
    assigningValues(val) {
      this.checkTerm = val;
      this.showTermsCondtion = false;
    },
  },
};
</script>

<style scoped>
.home-b2b {
  padding-top: 64px;
}
.btn-xs {
  padding: 0.25rem 0.6rem;
  font-size: 0.8rem;
}
.text-dark-blue {
  color: #002196;
}
.rounded-xl {
  border-radius: 16px;
}
.gap-2 {
  gap: 0.75rem;
}
.max-w-700 {
  max-width: 700px;
}
</style>
